var render = function () {
  var _class;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({}, 'v-card', _vm.$attrs, false), [_c('v-card-title', {
    staticClass: "subtitle-2",
    class: (_class = {}, _class[_vm.titleColor || ''] = true, _class)
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": _vm.color,
      "size": "20"
    }
  }, [_vm._v(_vm._s(_vm.icon))]), _vm._t("label", [_vm._v(_vm._s(_vm.label))])], 2), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }